import styled, { css } from 'styled-components';

export const ModalContent = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    margin: ${theme.sz.s12};
    gap: ${theme.sz.s6};

    @media (max-width: ${theme.sz.md}) {
      margin: ${theme.sz.s6};
      gap: ${theme.sz.s4};
    }
  `,
);

export const Description = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.l};

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.m};
    }
  `,
);

export const ModalHeader = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.m};

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.heading.mobile.s};
    }
  `,
);

export const ProgressIndicator = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};
    color: ${theme.co.secondary50};

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.m};
    }
  `,
);
